import { useOrganizador } from '../contexts/OrganizadorContext';

/**
 * Hook que retorna o label correto para "Curral" baseado na config do organizador.
 * Organizadores de RS/SC podem configurar para exibir "Mangueira" em vez de "Curral".
 * 
 * @returns {string} "Curral" ou "Mangueira"
 */
export function useLabelCurral() {
  const { organizadorAtivo } = useOrganizador();
  return organizadorAtivo?.label_curral || 'Curral';
}
